import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const breadCrumbItemActive = "omponents__Breadcrumbs__components__BreadcrumbItem__BreadcrumbItem_styles_ts-breadCrumbItemActive-b1pqz4lb";
export const breadCrumbItem = "omponents__Breadcrumbs__components__BreadcrumbItem__BreadcrumbItem_styles_ts-breadCrumbItem-b1gq5emp";

require("./BreadcrumbItem.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./BreadcrumbItem.styles.ts");